import { Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { HelperService } from './services/helper.service';
import { TranslateService } from './services/translate.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'sampark-ui';
  display: boolean = false;
  isErrorListDisplay: boolean = false;
  errorList: any = [];
  stickyMsg: string = '';
  isStickyMsgDisplay: boolean = false;
  isProduction: boolean = false;
  selectedSevaType: any;

  constructor(
    private translateService: TranslateService,
    private helper: HelperService,
    private swUpdate: SwUpdate) {
    if (environment.production) {
      console.log = () => {};
    }
  }

  ngOnInit() {
    this.translateService.translate();
    try {
      if (this.swUpdate.isEnabled) {
        this.swUpdate.checkForUpdate().then((res: any) => {
          if(res) {
            this.display = true;
            console.log("New Version Available");
            // this.authService.logout();
          }
        })
      }
    } catch(e) {}

    // Error Message (Configure with Server)
    this.helper.errorListEmitter.subscribe((errList: any) =>{
      if(typeof errList === 'object') {
        this.errorList = Object.values(errList);
        this.isErrorListDisplay = true;
      }
    })

    // Sticky Message (Configure with Server)
    this.helper.stickyMessageEmitter.subscribe((stickyMsg: any) =>{
      console.log("stickyMsg", stickyMsg);
      
      if(!!stickyMsg) {
        this.stickyMsg = stickyMsg;
        this.isStickyMsgDisplay = true;
      }
    })

  }

  updateVersion() {
    this.display = false;
    window.location.reload();
  }
}
